import moment from "moment-timezone";

function createJsonFinishActivity(contract) {
  let OsRequestContract = {
    accredited: contract.accredited,
    numberPhone: contract.numberPhone,
    codeCity: contract.city.value,
    initialTime: contract.initialTime,
    conclusionTime: contract.conclusionTime,
    contractNumber: contract.contractNumber !== "" ? contract.contractNumber : "0",
    typeAttendance: 19,
    dateStartedAttendance: contract.dateStartedAttendance ?? "",
    dateFinishedAttendance: moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss"),
    isOwnTechnician: contract.isOwnTechnician ?? false,
    technicianCode: contract.technicianCode ?? "",
    accreditedCode: contract.accreditedCode ?? "",
    osRequests: contract.solicitations.map((item) => {
      if (Object.keys(item).includes("typeOS") && item.typeOS != null) {
        item.typeOS = item.typeOS.value;
      }
      return item;
    }),
  };
  return OsRequestContract
}
export default createJsonFinishActivity;
